import { render, staticRenderFns } from "./SimulationsIndex.vue?vue&type=template&id=377f294d"
import script from "./SimulationsIndex.vue?vue&type=script&lang=js"
export * from "./SimulationsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports